import type { DateOfBirthType } from 'src/components/date-of-birth-input/types';
import { MIN_VALID_AGE } from 'src/components/date-of-birth-input/constants';

import { convertToDate } from '../convert-to-date';

export const validateDateOfBirth = (dateOfBirth: DateOfBirthType) => {
    const convertedDate = convertToDate(dateOfBirth);

    if (!convertedDate) {
        return false;
    }

    const birthYear = convertedDate?.getFullYear();

    const currentYear = new Date().getFullYear();

    const age = currentYear - birthYear;

    return age >= MIN_VALID_AGE;
};
